import { SchemaField } from '../../../legacy/objects/generic/serialization/schema-field';
import { SerializableObjectSchema } from '../../../legacy/objects/generic/serialization/serializable-object-schema';

export class SessionURLSchema extends SerializableObjectSchema {
  public static readonly baseUrl = 'baseUrl';

  public static readonly searchParams = 'searchParams';

  ////////////////////////////////////////////////////////////////////////////////////////////////
  // Schema Parameters
  ////////////////////////////////////////////////////////////////////////////////////////////////

  public getSchemaDefinition(): { [key: string]: import('joi').AnySchema } {
    const parameters: { [key: string]: import('joi').AnySchema } = {};

    parameters[SessionURLSchema.baseUrl] = SchemaField.string(undefined).required();
    parameters[SessionURLSchema.searchParams] = SchemaField.mapOfType(
      SchemaField.string(undefined),
      undefined,
    ).optional();

    return parameters;
  }
}
